import * as React from 'react';

const ButtonDropdownGridRow = ({ className , children  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: className,
        role: "row"
    }, children);
};

export { ButtonDropdownGridRow };
//# sourceMappingURL=ButtonDropdownGridRow.js.map
